import { useGoogleLogin } from 'apis/auth/use-google-login';
import { Heading, Text } from 'design-system';
import { Layout, Section } from 'layout';
import { GoogleLoginButton } from 'pages/login/components/google-login-button';

const LoginPage = () => {
  useGoogleLogin();

  return (
    <Layout type='pre_login_page_layout'>
      <Section name='content'>
        <Heading as='h1' fontSize='2xl' mb='sm'>
          Sign in
        </Heading>

        <Text color='gray.500' mb='lg'>
          Access is by invitation. Ask your line manager if you need one.
        </Text>

        <GoogleLoginButton />
      </Section>
    </Layout>
  );
};

export default LoginPage;
